<template>
  <div v-wechat-title="title" style="float:left;width: 100%;">
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane v-if="recoveryApplicationInterval && recoveryApplicationInterval > 0" :label="`等待复苏`"
            name="unRecoveries">
            <div style="margin: 0 10px;width: 97%;">
                <list-view ref="unRecoverieslist" :showSequence="true" :columns="columnList" :datalist="unRecoveries"
                    :tableHeight="tableHeight"></list-view>
            </div>
        </el-tab-pane>
        <el-tab-pane label="复苏床位" name="recoveryBed">
            <div style="margin:20px;" class="tag-group">
                <div v-for="item in recoverylist" :key="item.id"
                    class="tag" :class="{used:(item.is_using || item.is_lock)?isUsed:!isUsed}"
                    style="margin-top:10px;position: relative;">{{item.name}}
                    <img v-if="item.is_intubate" style="height: 24px;position:absolute;right:5px;bottom: 5px;" :src="intubateImg" />
                </div>
            </div>
            <p v-if="!recoveryApplicationInterval || recoveryApplicationInterval == 0" style="float:left;margin:20px 40px;">等待复苏：{{this.recoveryCount}}人</p>
        </el-tab-pane>

    </el-tabs>
  </div>

</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `ReviveList`,
    props: {

    },
    data() {
        return {
            title: `复苏床位`,
            token: this.$route.query.token,
            surgeryId: this.$route.query.surgery_id,
            recoveryCount: ``,
            activeName: `recoveryBed`,
            recoveryApplicationInterval: this.$root.RecoveryApplicationInterval,
            unRecoveries: [],
            recoverylist: [],
            allCount: 0,
            sindex: 0,
            isUsed: true
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.loadRecoveryBedUsing()
        if (this.recoveryApplicationInterval && this.recoveryApplicationInterval > 0) {
            this.loadUnRecoveries()
        }
    },
    computed: {
        ...mapGetters([`sys_enums`, `img_icons`, `screenHeight`]),
        tableHeight() {
            return (this.screenHeight && this.screenHeight - 120) || 0
        },
        intubateImg() {
            return `../../../static/img/baguan1.png`
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                width: `80`,
                isKey: true
            },
            {
                type: `datetime`,
                prop: `plan_time`,
                label: `申请时间`,
                width: `150`,
                isListable: true
            },
            {
                type: `select`,
                prop: `enum_message_status`,
                label: `申请状态`,
                width: `90`,
                isListable: true,
                options: this.sys_enums.Enum_RecoveryMessageStatus
            },
            {
                type: `string`,
                prop: `dic_operating_room`,
                label: `手术间`,
                width: `90`,
                isListable: true
            },
            {
                type: `string`,
                prop: `patient_name`,
                label: `患者姓名`,
                width: `100`,
                isListable: true
            },
            {
                type: `string`,
                prop: `visit_no`,
                label: `住院号`,
                width: `100`,
                isListable: true
            },
            {
                type: `string`,
                prop: `anes_doctor`,
                label: `麻醉医生`,
                width: `100`,
                isListable: true
            }]
        }
    },
    methods: {
        handleClick(tab, event) {
            if (tab && tab.name) {
                if (tab.name == `recoveryBed`) {
                    this.loadRecoveryBedUsing()
                } else if (tab.name == `unRecoveries`) {
                    this.loadUnRecoveries()
                }
            }
        },
        loadUnRecoveries() {
            let that = this
            let url = `/api/Operation/RecoveryApplyMessage/GetUnInRoomRecoveryApplyMessageByRoomId?opRoomId=${this.$route.query.room_id}`
            let req = that.myaxios.get(url)
            req.then(data => {
                // current_key_event =1 （已申请）， current_key_event =2 （已撤回）， current_key_event =3 （已同意）， current_key_event =4 （等待）
                that.unRecoveries = _.filter(data, i => i.current_key_event != 2 && i.current_key_event != 3).map((i, index) => {
                    if (i.id == that.surgeryId) {
                        i.row_style = { 'font-weight': `600`, color: `#3191e9` }
                        that.sindex = index + 1
                    }
                    i.enum_message_status = i.current_key_event
                    return i
                })
                that.allCount = that.unRecoveries.length
                console.log(that.unRecoveries)
            })
        },
        loadRecoveryBedUsing() {
            return new Promise((resolve) => {
                let req = this.myaxios.get(`/api/Postoperative/Recovery/GetBedUsing`, { opRoomId: this.$route.query.room_id })
                let req1 = this.myaxios.get(`/api/Postoperative/Recovery/GetWaitingCount`, { opRoomId: this.$route.query.room_id })
                this.myaxios.all(req, req1).then(([data, data1]) => {
                    this.recoverylist = data
                    this.recoveryCount = data1
                    console.log(data)
                })
            })
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.tag{
  width: 100px;
  height: 50px;
  line-height: 50px;
  border-radius: 10px;
  float: left;
  margin-left: 20px;
  background: var(--primary-color, #009688);
  color:#fff;
}
.used{
  background: #cccccc;
  color:#000;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/Revive.vue